<app-frame [overlay]="false" [title]="title" (neadClose)="closeVisitForm()" autocomplete="off" class="align-title">
	<div class="visit-dialog-content">
		Would you like to enter more visits to a {{data.type | lowercase}}?
	</div>
	<app-form-actions-content>
		<form-button (clickOnButton)="btnClick('yes')">Yes</form-button>
		<form-button (clickOnButton)="btnClick('no')" buttonType="warning">No</form-button>
	</app-form-actions-content>
</app-frame>
